/**
 * 前端配置文件 - 统一管理前端启动端口、后端连接等配置
 */

const config = {
  // 前端开发服务器配置
  frontend: {
    //port: process.env.PORT || 3000, // 前端开发服务器端口
    port: process.env.PORT || 80, // 前端开发服务器端口（服务器上的配置）
    //host: process.env.HOST || 'localhost' // 前端开发服务器主机
    host: process.env.HOST || 'xianzhuli.ligelige.cn' // 前端开发服务器主机（服务器上的配置）
  },

  // 后端API配置
  backend: {
    // API基础URL
    //apiUrl: process.env.REACT_APP_API_URL || 'http://localhost:15000/api',
    apiUrl: process.env.REACT_APP_API_URL || '/api', //（服务器上的配置）
    // 后端服务器地址和端口
    //host: process.env.REACT_APP_BACKEND_HOST || 'localhost',
    //port: process.env.REACT_APP_BACKEND_PORT || 5000,
    // 完整的后端基础URL（不包含/api路径）
    //baseUrl: process.env.REACT_APP_BACKEND_BASE_URL || 'http://localhost:5000'
  },


  // 应用配置
  app: {
    name: '闲鱼助理系统',
    version: '1.0.0',
    // 是否启用开发模式
    isDevelopment: process.env.NODE_ENV === 'development',
    // 是否启用生产模式
    isProduction: process.env.NODE_ENV === 'production'
  },

  // 请求配置
  request: {
    // 请求超时时间（毫秒）
    timeout: parseInt(process.env.REACT_APP_REQUEST_TIMEOUT) || 10000,
    // 是否携带凭证
    withCredentials: true
  },

  // 认证配置
  auth: {
    // Token存储键名
    tokenKey: 'token',
    // 用户信息存储键名
    userKey: 'user'
  },

  // 轮询配置
  polling: {
    // 任务状态检查间隔（毫秒）
    taskStatusInterval: parseInt(process.env.REACT_APP_TASK_POLLING_INTERVAL) || 3000,
    // 任务列表刷新间隔（毫秒）
    taskListInterval: parseInt(process.env.REACT_APP_TASK_LIST_INTERVAL) || 5000
  }
};

export default config;

// 兼容CommonJS导出
if (typeof module !== 'undefined' && module.exports) {
  module.exports = config;
}